import DsChip, { type ChipProps } from '@carvana/ds-chip';
import cx from 'classnames';
import { useDeviceType } from '~/context/common/DeviceContext';

type OwnProps = React.PropsWithChildren<ChipProps>;

export default function Chip({ children, ...props }: OwnProps) {
  const { className, ...rest } = props;
  const { isMobile, isTablet } = useDeviceType();

  return (
    <DsChip
      {...rest}
      className={cx(className, {
        'active:!border-border-weak active:!bg-background-default active:!text-text-default':
          isMobile || isTablet
      })}
    >
      {children}
    </DsChip>
  );
}
